import {SimpleGrid} from '@chakra-ui/react';
import {ProviderListSkeleton} from 'components/shared';
import {FC, PropsWithChildren} from 'react';

interface IProps {
  conditionValue: boolean;
}

const skeletonArray = new Array(20).fill(1);

export const ProviderTileWithSkeletion: FC<PropsWithChildren<IProps>> = ({conditionValue, children}) => {
  return (
    <>
      {conditionValue ? (
        <SimpleGrid
          columns={[1, 4]}
          gridGap={['20px', '30px']}
          mx={[0, '20px']}
          as="ul"
          listStyleType="none"
          ml="-20px"
        >
          {skeletonArray.map((_, index) => (
            <ProviderListSkeleton key={index} />
          ))}
        </SimpleGrid>
      ) : (
        <>{children}</>
      )}
    </>
  );
};
